module.exports = __webpack_public_path__ + "static/media/cross.7c645b96.svg";